export type NumGen = () => number;

export function rngSeed(seed: number = 123456) {
  let s = seed;
  const fn: NumGen = () => {
    let t = (s += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return fn;
}

export function pick<T>(rng: NumGen = Math.random, arr: T[]) {
  return arr[Math.floor(rng() * arr.length)];
}

export function between(rng: NumGen = Math.random, min: number, max: number) {
  return Math.floor(rng() * (max - min + 1) + min);
}

export function random(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

type Pick = <T>(a: T[]) => T;
type Picker = <T>(a: T[]) => () => T;
type Between = (min: number, max: number) => number;

export interface Rng {
  (): number;
  pick: Pick;
  picker: Picker;
  between: Between;
}

export const Rng = (seed: number) => {
  const _r = rngSeed(seed);

  const pick = <T,>(arr: T[]) => arr[Math.floor(_r() * arr.length)];
  const picker: Picker = (a) => () => pick(a);
  const between: Between = (i, j) => Math.floor(_r() * (j - i + 1) + i);

  const interf = {
    r: _r,
    pick,
    picker,
    between,
  };

  Object.assign(_r, interf);
  Object.setPrototypeOf(_r, Object.getPrototypeOf(interf));

  return _r as Rng;
};
